"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @jsx jsx */

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("@emotion/react");

var react_2 = require("react");

var Container_1 = require("./Container");

var Column_1 = require("./Column");

var Row_1 = require("./Row");

var Section_1 = require("./Section");

var Card_1 = require("./Card");

var Headings_1 = require("./Headings");

var Text_1 = require("./Text");

var Share_1 = require("./Share");

var Header_1 = require("./Header");

var Image = styled_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 100%;\n"], ["\n  max-width: 100%;\n"])));
exports.elements = {
  link: function link() {
    return react_1.jsx("span", null, "link");
  },
  languageselector: function languageselector() {
    return react_1.jsx("span", null, "languageselector");
  },
  usermenu: function usermenu() {
    return react_1.jsx("span", null, "usermenu");
  },
  column: function column(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Column_1.Column, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  row: function row(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Row_1.Row, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  container: function container(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Container_1.Container, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  section: function section(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Section_1.Section, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  card: function card(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Card_1.Card, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  cardheader: function cardheader(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Card_1.CardHeader, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  cardbody: function cardbody(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Card_1.CardBody, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  header: function header(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Header_1.Header, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  headermenu: function headermenu(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Header_1.HeaderMenu, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  headeritem: function headeritem(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        children = _a.children,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Header_1.HeaderItem, __assign({}, properties, {
      css: generatedCss
    }), children);
  },
  html: function html(_a) {
    var _b = _a.element,
        _c = _b.properties,
        properties = _c === void 0 ? {} : _c,
        content = _b.content,
        contentLocalized = _b.contentLocalized,
        generatedCss = _a.generatedCss,
        culture = _a.culture;

    var _d;

    return react_1.jsx(Text_1.Text, __assign({}, properties, {
      dangerouslySetInnerHTML: {
        __html: culture && ((_d = contentLocalized) === null || _d === void 0 ? void 0 : _d[culture]) || content || ''
      },
      css: generatedCss
    }));
  },
  image: function image(_a) {
    var _b = _a.element,
        _c = _b.properties,
        properties = _c === void 0 ? {} : _c,
        content = _b.content,
        tenantId = _a.tenantId,
        generatedCss = _a.generatedCss;
    return react_1.jsx(Image, __assign({}, properties, {
      src: "https://media.nimles.com/file/" + tenantId + "/" + content + "?width=860",
      css: generatedCss
    }));
  },
  heading1: function heading1(_a) {
    var _b = _a.element,
        _c = _b.properties,
        properties = _c === void 0 ? {} : _c,
        content = _b.content,
        contentLocalized = _b.contentLocalized,
        generatedCss = _a.generatedCss,
        culture = _a.culture;

    var _d;

    return react_1.jsx(Headings_1.Heading1, __assign({}, properties, {
      dangerouslySetInnerHTML: {
        __html: culture && ((_d = contentLocalized) === null || _d === void 0 ? void 0 : _d[culture]) || content || ''
      },
      css: generatedCss
    }));
  },
  heading2: function heading2(_a) {
    var _b = _a.element,
        _c = _b.properties,
        properties = _c === void 0 ? {} : _c,
        content = _b.content,
        contentLocalized = _b.contentLocalized,
        generatedCss = _a.generatedCss,
        culture = _a.culture;

    var _d;

    return react_1.jsx(Headings_1.Heading2, __assign({}, properties, {
      dangerouslySetInnerHTML: {
        __html: culture && ((_d = contentLocalized) === null || _d === void 0 ? void 0 : _d[culture]) || content || ''
      },
      css: generatedCss
    }));
  },
  heading3: function heading3(_a) {
    var _b = _a.element,
        _c = _b.properties,
        properties = _c === void 0 ? {} : _c,
        content = _b.content,
        contentLocalized = _b.contentLocalized,
        generatedCss = _a.generatedCss,
        culture = _a.culture;

    var _d;

    return react_1.jsx(Headings_1.Heading3, __assign({}, properties, {
      dangerouslySetInnerHTML: {
        __html: culture && ((_d = contentLocalized) === null || _d === void 0 ? void 0 : _d[culture]) || content || ''
      },
      css: generatedCss
    }));
  },
  heading4: function heading4(_a) {
    var _b = _a.element,
        _c = _b.properties,
        properties = _c === void 0 ? {} : _c,
        content = _b.content,
        contentLocalized = _b.contentLocalized,
        generatedCss = _a.generatedCss,
        culture = _a.culture;

    var _d;

    return react_1.jsx(Headings_1.Heading4, __assign({}, properties, {
      dangerouslySetInnerHTML: {
        __html: culture && ((_d = contentLocalized) === null || _d === void 0 ? void 0 : _d[culture]) || content || ''
      },
      css: generatedCss
    }));
  },
  heading5: function heading5(_a) {
    var _b = _a.element,
        _c = _b.properties,
        properties = _c === void 0 ? {} : _c,
        content = _b.content,
        contentLocalized = _b.contentLocalized,
        generatedCss = _a.generatedCss,
        culture = _a.culture;

    var _d;

    return react_1.jsx(Headings_1.Heading5, __assign({}, properties, {
      dangerouslySetInnerHTML: {
        __html: culture && ((_d = contentLocalized) === null || _d === void 0 ? void 0 : _d[culture]) || content || ''
      },
      css: generatedCss
    }));
  },
  heading6: function heading6(_a) {
    var _b = _a.element,
        _c = _b.properties,
        properties = _c === void 0 ? {} : _c,
        content = _b.content,
        contentLocalized = _b.contentLocalized,
        generatedCss = _a.generatedCss,
        culture = _a.culture;

    var _d;

    return react_1.jsx(Headings_1.Heading6, __assign({}, properties, {
      dangerouslySetInnerHTML: {
        __html: culture && ((_d = contentLocalized) === null || _d === void 0 ? void 0 : _d[culture]) || content || ''
      },
      css: generatedCss
    }));
  },
  share: function share(_a) {
    var _b = _a.element.properties,
        properties = _b === void 0 ? {} : _b,
        generatedCss = _a.generatedCss,
        location = _a.location;

    var _c;

    return react_1.jsx(Share_1.Share, __assign({}, properties, {
      css: generatedCss,
      href: (_c = location) === null || _c === void 0 ? void 0 : _c.href
    }));
  }
};

exports.Element = function (_a) {
  var tenantId = _a.tenantId,
      element = _a.element,
      location = _a.location,
      root = _a.root,
      parent = _a.parent,
      culture = _a.culture,
      index = _a.index;

  var _b, _c, _d;

  var styles = !element.styles ? '' : Object.entries(element.styles).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    return key + ": " + value + ";";
  }).join(' ');
  var Component = ((_b = element) === null || _b === void 0 ? void 0 : _b.type) && exports.elements[element.type.toLowerCase()];
  var generatedCss = react_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n  "])), styles, element.css);
  return !Component ? null : react_1.jsx(Component, {
    element: element,
    tenantId: tenantId,
    generatedCss: generatedCss,
    location: location,
    root: root,
    parent: parent,
    culture: culture,
    index: index
  }, (_d = (_c = element.children) === null || _c === void 0 ? void 0 : _c.map(function (element, index) {
    var _a;

    return react_1.jsx(exports.Element, {
      key: element.id,
      tenantId: tenantId,
      element: element,
      location: location,
      root: root,
      parent: (_a = element.type, _a !== null && _a !== void 0 ? _a : undefined),
      culture: culture,
      index: index
    });
  }), _d !== null && _d !== void 0 ? _d : null));
};

exports.ElementList = function (_a) {
  var tenantId = _a.tenantId,
      elements = _a.elements,
      location = _a.location,
      root = _a.root,
      culture = _a.culture;

  var _b;

  return react_1.jsx(react_2.Fragment, null, (_b = elements) === null || _b === void 0 ? void 0 : _b.map(function (element, index) {
    return react_1.jsx(exports.Element, {
      key: element.id,
      tenantId: tenantId,
      element: element,
      location: location,
      root: root,
      parent: root,
      culture: culture,
      index: index
    });
  }));
};

var templateObject_1, templateObject_2;